<template>
  <el-popover
    ref="helpMenuRef"
    v-model="visible"
    trigger="click"
    placement="right-end"
    :width="160"
    :popper-class="b('popper')"
    :visible-arrow="false"
    @show="onShow"
    @after-leave="onAfterHide"
  >
    <template #reference>
      <el-row
        id="help_center_close-module-guide"
        type="flex"
        align="middle"
        justify="center"
        :class="[b('ref'), { 'is-active': isActive }]"
      >
        <div :class="b('container')">
          <template v-if="helpIconSegment && !visible">
            <el-new-badge
              ref="updateNewBadge"
              :segments="helpIconSegment"
              placement="right-start"
              :hidden="isOverseasVersion ? !versionClosed : false"
            >
              <em class="zkicon iconbangzhuzhongxin1" />
            </el-new-badge>
          </template>
          <em
            v-else
            class="zkicon iconbangzhuzhongxin1"
          />
        </div>
      </el-row>
    </template>

    <div
      v-if="isActive"
      :class="b('menu')"
    >
      <template v-for="(group, index) of menus">
        <el-divider
          v-if="index > 0"
          :key="group.key"
        />
        <template v-for="menu of group.children">
          <VersionPopover
            :key="menu.key"
            v-loading="menu.loading"
            :value="menu.newSegments && !versionClosed"
            placement-position="right"
            width="296"
            @resetPosition="resetPosition"
          >
            <DropdownItem
              v-if="menu.hidden !== true"

              :id="menu.id"
              slot="reference"
              :key="menu.key"
              :class="b('item', { breathe: menu.newSegments && !versionClosed})"
              :icon="menu.icon"
              :title="menu.label"
              :new-segments="menu.newSegments"
              :blank="menu.blank"
              :hot-key="menu.hotKey"
              @click="menu.fn"
            />
          </VersionPopover>
        </template>
        <div
          v-if="group.content"
          :key="group.key"
          :class="b('item-content')"
        >
          <div :class="b('desc')">
            {{ $t('version.popover.desc') }}
          </div>
          <el-link
            type="primary"
            :class="b('refresh-link')"
            @click.stop="handleReload"
          >
            {{ $t('version.popover.refresh') }}
          </el-link>
        </div>
      </template>
    </div>

    <FeedBackDialog
      v-if="showFeedback"
      @close="showFeedback = false"
    />
    <HotKeysDialog
      v-if="showHotKeys"
      @close="showHotKeys = false"
    />
  </el-popover>
</template>

<script>
import { resolveUrl } from '@zk/framework-vue';
import theme from '@zk/theme/lib/variables.scss';
import DropdownItem from 'common-module/src/components/DropdownItem';
import VersionPopover from './menu/PushPopover';
import {
  defineComponent
} from '@vue/composition-api';
import { locationRefresh } from '@/utils';
// 帮助icon已经完成的版本的UG属性名
// const HELP_ICON_NEW_FINISH_VERSION = 'helpIconNewFinishVersion';
// 更新日志是否完成的属性名
import { useMQHook } from '@/layouts/utils/kf.js';
import { isPrivateVersion } from 'common-module/src/util';
/* eslint-disable */
                 
const isAbroad = true;
        
                       
         
/* eslint-disable */

export default defineComponent({
  name: 'HelpMenu',
  bemNS: theme.bemNS,
  components: {
    DropdownItem,
    FeedBackDialog: () => import('./FeedBackDialog'),
    HotKeysDialog: () => import('./HotKeysDialog'),
    VersionPopover
  },
  shortcutsEvents() {
    return [
      {
        key: '?',
        type: 'global',
        callback: () => {
          this.openHotKeys();
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: '?',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      },
      {
        key: '？',
        type: 'global',
        callback: () => {
          this.openHotKeys();
          this.$track.send('Hotkeys', {
            Hotkeys_Scope: '全局',
            Hotkeys_Name: '?',
            Hotkeys_Path: this.$route.path,
            Has_Dialog: false
          }, true);
        }
      }
    ];
  },
  data() {
    return {
      showHotKeys: false,
      showFeedback: false,
      visible: false,
      isActive: false,
      showTooltip: true
    };
  },
  setup(){
    const { rollCheckMQ, MQLoading, timer } = useMQHook();
    return {
      rollCheckMQ,
      MQLoading,
      timer
    }
  },
  computed: {
    menus() {
      const list = [{
        key: 'functions',
        children: [{
          key: 'highlights',
          label: this.$t('navbar.highlights'),
          icon: 'zkicon iconliangdiangongneng',
          fn: this.openHighlights
        }, {
          key: 'hotkeys',
          label: this.$t('navbar.hotkeys.dialog'),
          icon: 'zkicon iconkuaijiejian',
          fn: this.openHotKeys,
          hotKey: ['Shift', '/']
        }]
      },
      {
        key: 'docs',
        children: [
          /* eslint-disable */
                           
                  
           
                          
                                            
                                            
                        
                                              
                                       
            
                    
          /* eslint-disable */
          {
            key: 'manual',
            label: this.$t('navbar.manual'),
            icon: 'zkicon iconshiyongshouce',
            blank: true,
            fn: this.openManual
          },
          {
            key: 'api',
            label: this.$t('navbar.apiDocument'),
            icon: 'zkicon iconAPIguanli-01',
            blank: true,
            fn: this.openApiDocuments,
            hotKey: []
          }
          /* eslint-disable */
                           
                  
            
                       
                                                 
                                   
                        
                                     
           
                    
          /* eslint-disable */
        ]
      }, {
        key: 'feedback',
        children: [{
          key: 'feedback',
          label: this.$t('navbar.feedback.title'),
          icon: 'zkicon iconyijianfankui',
          fn: this.openFeedBack,
          hidden: isAbroad || this.isPrivateVersion,
        }, {
          key: 'kf',
          label: this.$t('navbar.kf'),
          icon: 'zkicon iconzaixiankefu',
          fn: this.openMeiQia,
          hidden: this.isPrivateVersion,
          loading: this.MQLoading
        }]
      }].filter(item => !item.hidden && item.children.filter(c => !c.hidden).length);
      if(this.helpIconSegment && this.versionClosed){
        const newItem = {key:'updateArray', content:this.versionClosed, children: list[1].children.splice(0, 1)};
        list.splice(1, 0, newItem);
      }
      return list;
    },
    versionClosed(){
      return this.$store.getters['app/versionClosed'];
    },
    currentUserId() {
      return this.$store.state.user.account.userId;
    },
    switchApiFox() {
      return this.$store.getters['features/isSwitch']('user:apifox_doc_switch');
    },
    helpIconSegment() {
      return this.$store.getters['app/isModelShow'];
    },
    isEnVersion() {
      return this.$store.state.user.org?.language?.includes('en');
    }
  },
  created() {
    // eslint-disable-next-line
    this.eventBus.$on('global:openMeiQia', this.handleOpenMeiQia);
  },
  beforeDestroy() {
    // eslint-disable-next-line
    this.eventBus.$off('global:openMeiQia', this.handleOpenMeiQia);
    clearInterval(this.timer);
    this.MQLoading = false;
  },
  methods: {
    resetPosition(){
      setTimeout(() => {
        this.$refs.helpMenuRef?.updatePopper();
      }, 0);
    },
    handleReload(){
      // window.location.reload();
      locationRefresh();
    },
    onShow() {
      this.isActive = true;
      this.$track.send('Helpdesk', {}, true);
      this.$emit('toggleShow', false);
    },
    onAfterHide() {
      this.isActive = false;
      this.$emit('toggleShow', true);
    },
    hide() {
      this.visible = false;
      this.$emit('toggleShow', true);
    },
    openHighlights(){
      this.eventBus.$emit('showVideo-highlights');
      this.hide();
      this.$track.send('Helpdesk_Guide', {}, true);
    },
    openHotKeys() {
      this.$track.send('Helpdesk_Shortcut', {}, true);
      this.showHotKeys = true;
      this.hide();
    },
    openApiDocuments() {
      this.$track.send('Helpdesk_API', {}, true);
      if (isPrivateVersion && this.isEnVersion){
        window.open(resolveUrl("https://share.apidog.com/5a741107-c211-410f-880c-048d1917c984"));
        this.hide();
        return;
      }
      const docUrl = isPrivateVersion ? this.$config.VUE_APP_OPENAPI_URL : !isAbroad && this.isEnVersion
        ? this.$config.VUE_APP_APIFOX_URL_EN
        : this.$config.VUE_APP_APIFOX_URL;

      window.open(resolveUrl(docUrl));
      this.hide();
    },
    openManual() {
      this.$track.send('Helpdesk_Maunal', {}, true);
      const lang = this.isEnVersion ? 'en' : 'zh';
      const url = isAbroad ? this.$config.VUE_APP_DOC_URL : `${this.$config.VUE_APP_DOC_URL}${lang}`;
      window.open(resolveUrl(url));
      this.hide();
    },
    async handleOpenMeiQia(cb){
      await this.openMeiQia();
      cb?.();
    },
    showMQPanel(){
      if (!window._MEIQIA?.loadEnd) {
        window._MEIQIA?.reloadMain?.(0);
        window._MEIQIA?.('showPanel');
        return this.rollCheckMQ();
      }
      // 主数据加载成功，但是match等相关加载失败
      if (window._MEIQIA?.loadEnd && !window.meiqia) {
        this.openFeedBack();
        return;
      }
      window._MEIQIA?.('showPanel');
      return this.rollCheckMQ()
    },
    async openMeiQia() {
      /* eslint-disable */
                       
                               
                  
              
      this.hide();
      window.Intercom?.('show');
               
      /* eslint-disable */
      this.$track.send('Helpdesk_online', {}, true);

    },
    openFeedBack() {
      this.$track.send('Helpdesk_feedback', {}, true);
      this.showFeedback = true;
      this.hide();
    },
    openIdeDocuments() {
      this.$track.send('Helpdesk_IDE', {}, true);
      if (this.isPrivateVersion) {
        window.open(this.$config.getDocUrl('PLUGINS_IDE_VIDEO'));
      } else {
        window.open(resolveUrl(`${this.$config.VUE_APP_WEBSITE}/integrations?isWeb=1`));
      }
      this.hide();
    },
    openUpdateDocument() {
      this.$track.send('Helpdesk_Release_Notes', {}, true);
      window.open(this.$config.getDocUrl('SYSTEM_CHANGE_LOG'), '_blank');
    }
  }
});
</script>

<style lang="scss">
@include b(help-menu) {
  @include e(ref) {
    display: inline-flex;
    width: 36px;
    height: 36px;
    border-radius: 14px;
    cursor: pointer;
    &:hover {
      background: rgba(#B7B6CD, 0.12);
    }
    @include when(active) {
      background: var(--primary-color);
      @include icon {
        color: #FFFFFF;
      }
    }
    @include icon {
      font-size: var(--size-font-6);
      color: #B7B6CD;
    }
  }
  @keyframes scaleBoxShadow {
      0% {
        box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
      }
      25% {
        box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
      }
      50% {
        box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
      }
      75% {
        box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
      }
      100% {
        box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
      }
    }
  @include e(container){
    pointer-events: none;
  }
  @include e(item-content){
    height: 62px;
    width: 100%;
    border-radius: 4px;
    padding: 8px 16px;
    background: var(--brand-transparent-hover);
    @include e(desc){
      font-size: 12px;
      color: var(--font-color-1);
    }
    @include e(refresh-link){
      &.el-link{
        font-size: 12px;
        margin-top: 12px;
        font-weight: 400;
      }
      font-size: 12px;
      margin-top: 12px;
      font-weight: 400;
      &::after{
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        height: 0;
        bottom: 0;
        border-bottom: 1px solid  var(--link-primary-color);
     }
    }
  }
  @include e(help-new){
    position: absolute;
    right: -5px;
    top: -5px;
  }
  @include e(menu) {
    .el-divider {
      margin: 8px 16px;
      width: calc(100% - 32px);
    }
  }
  @include e(popper) {
    width: 240px !important;
    @include when(popper, el-) {
      padding: 8px;
    }
  }
  @include e(item){
    position: relative;
    @include m(breathe){
      // animation: 3s infinite linear scaleBoxShadow;
      // border: 1px solid var(--primary-color) ;
      // border-radius: 6px !important;
    }
  }
}
.zk-help-menu__ref .el-new-badge[hidden]{
  .el-new-badge__icon{
    display: none;
  }
}
</style>
